// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__IOHps","title":"style_title___izB5","arrow":"style_arrow__gILut"};